/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdminSyncAuthzRelationshipPoliciesRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {AdminSyncAuthzRelationshipPoliciesResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const adminSyncAuthzRelationshipPolicies = (request:AdminSyncAuthzRelationshipPoliciesRequest, options?: CashRequestOptions) => post<AdminSyncAuthzRelationshipPoliciesRequest, AdminSyncAuthzRelationshipPoliciesResponse>("/2.0/cash/admin-sync-authz-relationship-policies", request, {...options, rejectOnError: true })